import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/**
 * Final CTA band — used on the home page and other pages.
 */
export default function CTA({ section }) {
  const { eyebrow, heading, paragraphs = [], ctas = [] } = section;
  return (
    <section className="relative bg-mist-off py-24 lg:py-32">
      <div className="container-mist">
        <div className="relative overflow-hidden rounded-md bg-white border border-mist-soft p-10 lg:p-16">
          <div className="relative flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
            <div className="max-w-2xl">
              {heading && (
                <h2 className="font-display text-3xl lg:text-4xl text-mist-navy leading-tight">{heading}</h2>
              )}
              {paragraphs[0] && (
                <p className="mt-4 text-sm text-mist-ink/70 max-w-xl">{paragraphs[0]}</p>
              )}
            </div>
            <div className="flex flex-col sm:flex-row flex-wrap gap-3">
              {ctas.map((c, i) => (
                <Link
                  key={c.href + c.label}
                  to={c.href}
                  data-testid={c.testid || `cta-btn-${i}`}
                  className="inline-flex items-center justify-center gap-2 bg-mist-navy text-white px-7 h-12 text-[11px] uppercase tracking-[0.22em] font-semibold rounded-md hover:bg-mist-navy/90 transition-all duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-mist-gold focus-visible:ring-offset-2"
                >
                  {c.label}
                  <ArrowRight className="h-4 w-4" aria-hidden />
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
